import ons from "onsenui";
import * as React from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";

export interface TextInputProps {
  className?: string;
  type?: string;
  title: string;
  value: string;
  onChange: (value: string) => void;
}

export class TextInput extends React.Component<TextInputProps, {}> {
  shouldComponentUpdate(nextProps: TextInputProps) {
    return (
      this.props.className !== nextProps.className ||
      this.props.type !== nextProps.type ||
      this.props.title !== nextProps.title ||
      this.props.value !== nextProps.value
    );
  }

  constructor(props: TextInputProps) {
    super(props);

    this.state = {};
  }

  mounted: boolean = false;

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  handleClick = () => {
    const buttons = [translate(STRINGS.CANCEL), translate(STRINGS.OK)];

    ons.notification
      .prompt(" ", {
        animation: "none",
        modifier: "material",
        cancelable: true,
        title: this.props.title,
        defaultValue: this.props.value,
        buttonLabels: buttons as any,
        inputType: this.props.type,
      } as any)
      .then(
        (result) => {
          if (!this.mounted) {
            return;
          }
          const value: string | null = result as any;
          if (value !== null && value !== this.props.value) {
            console.log(value);
            this.props.onChange(value);
          }
        },
        () => {
          // Dialog was canceled
        }
      );
  };

  render() {
    return (
      <div
        onClick={this.handleClick}
        className={
          "TextInput__root " + (this.props.className === undefined ? "" : this.props.className)
        }
      >
        {this.props.value.length === 0 ? "\u00A0" : this.props.value}
      </div>
    );
  }
}
